/* eslint-disable prefer-rest-params */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AnalyticsProvider: function() {
        return AnalyticsProvider;
    },
    _AnalyticsProvider: function() {
        return _AnalyticsProvider;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _AnalyticsContext = require("./AnalyticsContext");
var _integrations = require("./integrations");
var _uuid = require("uuid");
var _jscookie = /*#__PURE__*/ _interop_require_default(require("js-cookie"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var supportedIntegrations = {
    ga: _integrations.GA,
    gtag: _integrations.GTag,
    segment: _integrations.Segment,
    amplitude: _integrations.Amplitude,
    meta: _integrations.Meta
};
var ssr = !(typeof window !== 'undefined' && window.document && window.document.createElement);
var COOKIE_NAME = 'composer_anonymous_id';
var proxyToIntegrations = function(integrations, func, args, disabledFunctions) {
    Object.keys(integrations).forEach(function(integrationKey) {
        var _disabledFunctions_integrationKey;
        var integration = integrations[integrationKey];
        if (disabledFunctions === null || disabledFunctions === void 0 ? void 0 : (_disabledFunctions_integrationKey = disabledFunctions[integrationKey]) === null || _disabledFunctions_integrationKey === void 0 ? void 0 : _disabledFunctions_integrationKey.includes(func)) {
            return;
        }
        // eslint-disable-next-line prefer-spread
        integration[func].apply(integration, args);
    });
};
var _AnalyticsProvider = function(_param) {
    var children = _param.children, _param_disabledFunctions = _param.disabledFunctions, disabledFunctions = _param_disabledFunctions === void 0 ? null : _param_disabledFunctions, props = _object_without_properties(_param, [
        "children",
        "disabledFunctions"
    ]);
    var anonymousId = (0, _react.useMemo)(function() {
        var id = _jscookie.default.get(COOKIE_NAME) || (0, _uuid.v1)();
        _jscookie.default.set(COOKIE_NAME, id, {
            expires: 365
        });
        return id;
    }, []);
    var integrations = (0, _react.useMemo)(function() {
        var enabledIntegrations = Object.keys(supportedIntegrations).filter(function(integration) {
            if (props[integration]) {
                return true;
            }
            return false;
        });
        return enabledIntegrations.reduce(function(acc, integration) {
            acc[integration] = new supportedIntegrations[integration](props[integration]);
            return acc;
        }, {});
    }, []);
    var context = (0, _react.useMemo)(function() {
        return {
            identify: function identify() {
                proxyToIntegrations(integrations, 'identify', Array.from(arguments), disabledFunctions);
            },
            group: function group() {
                proxyToIntegrations(integrations, 'group', Array.from(arguments), disabledFunctions);
            },
            page: function page() {
                proxyToIntegrations(integrations, 'page', Array.from(arguments), disabledFunctions);
            },
            track: function track() {
                proxyToIntegrations(integrations, 'track', Array.from(arguments), disabledFunctions);
            },
            user: function() {
                return {
                    anonymousId: anonymousId
                };
            },
            reset: function reset() {
                proxyToIntegrations(integrations, 'reset', Array.from(arguments), disabledFunctions);
            },
            revenue: function revenue() {
                proxyToIntegrations(integrations, 'revenue', Array.from(arguments), disabledFunctions);
            }
        };
    }, [
        anonymousId
    ]);
    return /*#__PURE__*/ _react.default.createElement(_AnalyticsContext.AnalyticsContext.Provider, {
        value: context
    }, children);
};
var AnalyticsProvider = function(props) {
    // Analytics is browser only. Just render what's in it.
    if (ssr) {
        return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, props.children);
    }
    return /*#__PURE__*/ _react.default.createElement(_AnalyticsProvider, props);
};
